import React, { useEffect, useMemo, useState } from "react";
import { getFetch, postFetch } from "../../../../../fetch/fetch";
import { tableUseStyle } from "../../etc/tableusestyle";
import StyledDataGrid from "../../newtodo/styles/tablestyles";
import { Button, Modal, ModalDialog } from "@mui/joy";
import { dateToDateString } from "../../etc/etcfunctions";
import { processTerminal } from "../functions/talktoterminal";
import ImageModal2 from "../../../use/imagemodal2";
import { Image } from "@mui/icons-material";
import AddGoodModal from "./addgood";
import AddGoodModalForRefund from "./addgoodforrefund";
import { set } from "lodash";

const PaidModal: React.FC<any> = (props: any) => {

    const classes = tableUseStyle();

    const [rows, setRows] = useState<any>([]);
    const [open3, setOpen3] = useState<boolean>(false);
    const [imageSrc, setImageSrc] = useState<string>("");
    const [loadingMap, setLoadingMap] = useState<Record<string, boolean>>({});

    const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
    const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);
    const [selectedPrice, setSelectedPrice] = useState<number>(0);
    const [selectedLinkedOrderId, setSelectedLinkedOrderId] = useState<number | null>(null);

    const setRowLoading = (orderId: string, isLoading: boolean) => {
        setLoadingMap(prev => ({ ...prev, [orderId]: isLoading }));
    };
    const columns = useMemo<any>(() => [
        {
            field: "goodId", headerName: "상품ID", width: 60
        },
        {
            field: "goodName", headerName: "상품명", width: 200
        },
        {
            field: "price", headerName: "상품금액", width: 90
        },
        {
            field: "kindName", headerName: "결제종류", width: 100
        },
        {
            field: "status", headerName: "결제상태", width: 100
        },
        {
            field: "amount", headerName: "결제금액", width: 100
        },
        {
            field: "forceImg", headerName: "증빙사진", width: 60, renderCell: (params: any) => {

                const id = params.row.id;
                const userId = params.row.userId;

                if (params.value) {

                    return (
                        <div
                            onClick={(e: any) => {
                                console.log(params.value);
                                setImageSrc(params.value);
                                setOpen3(true);

                            }}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                height: "100%",
                                cursor: "pointer"
                            }}>
                            <Image color="success" />
                        </div>
                    )

                } else {
                    return (
                        <div style={{
                            
                        }}>
                            -
                        </div>
                    )
                }

            }
        },
        {
            field: "createdAt", headerName: "결제일자", width: 200
        },
        {
            field: "cancelBtn", headerName: "결제취소", width: 120,
            sortable: false,
            renderCell: (params: any) => {
                const index = params.row.index;
                const toBeCanceled = params.row.toBeCanceled;
                const orderId = params.row.orderId;

                const startDate = params.row.startDate;
                const endDate = params.row.endDate;
                const price = params.row.amountRaw;

                const isLoading = !!loadingMap[orderId];

                const goToBeCanceled = async () => {
                    
                    console.log("orderId");
                    console.log(orderId);

                    // if (!window.confirm("해당 상품에 대한 환불 상품을 생성하시겠습니까?")) {
                    //     return;
                    // }



                    if (!window.confirm("정말로 해당 결제를 결제취소 예정으로 변경하시겠습니까?")) {
                        return;
                    }

                    setRowLoading(orderId, true);

                    const result: any = await postFetch("/dashboard/payments/managepayment/toBeCanceled", {
                        orderId
                    });

                    setRowLoading(orderId, false);

                    if (result.message === "success") {
                        props.notify16();
                        props.setUpdate(Math.random());
                    }
                }

                const goCancelPayment = async () => {

                    if (!window.confirm("정말로 해당 결제를 취소시키겠습니까?")) {
                        return;
                    }

                    setRowLoading(orderId, true);

                        if (params.row.type === "payTeacher") {

                            const checkIfOrderItemIsZero = async () => {
                                const orderId = params.row.orderId;
                                const result: any = await postFetch("/dashboard/payments/managepayments/checkiforderitemiszero", {
                                    orderId
                                });
                                return result.isZero;
                            }

                            const payTeacherBillId = params.row.payTeacherBillId;
                            console.log("payTeacherBillId");
                            console.log(payTeacherBillId);

                            const result: any = await postFetch("/dashboard/payments/managepayments/destroyorcancelpaymentlink", {
                                type: "cancel",
                                billId: payTeacherBillId
                            });

                            if (result.message === "success") {

                                await checkIfOrderItemIsZero();

                                props.notify9();
                                props.setUpdate(Math.random());
                                //남은 결제금액이 0이면 order_item 삭제시키기
                            } else {
                                props.notify8();
                                alert(result.detail);
                            }

                        }

                        if(params.row.type === "terminal" || params.row.type === "forcePayment" || params.row.type === "withdrawal") {

                            const checkIfOrderItemIsZero = async () => {
                                const orderId = params.row.orderId;
                                const result: any = await postFetch("/dashboard/payments/managepayments/checkiforderitemiszero", {
                                    orderId
                                });
                                return result.isZero;
                            }

                            const paymentId = params.row.id;
                            console.log("paymentId");
                            console.log(paymentId);

                            const result : any = await postFetch("/dashboard/payments/managepayments/cancelconfirmpayment", {
                                paymentId,
                                type : params.row.type
                            })

                            if (result.message === "success") {
                                
                                await checkIfOrderItemIsZero();

                                props.notify9();
                                props.setUpdate(Math.random());

                            } else {
                                props.notify8();
                                alert(result.detail);
                            }

                        }

                    setRowLoading(orderId, false);

                }


                if (index > 0 && !toBeCanceled) {
                    return (<div></div>);
                }

                if (index === 0 && !toBeCanceled) {
                    return (
                        <Button
                            variant="outlined"
                            color="neutral"
                            size="sm"
                            onClick={() => {
                                goToBeCanceled();
                            }}
                            fullWidth
                            loading={isLoading}
                        >
                            결제취소 예정
                        </Button>
                    )
                }

                if (toBeCanceled && params.row.type === "payTeacher" && !params.row.canceledAt) {
                    return (
                        <Button
                            variant="outlined"
                            color="danger"
                            size="sm"
                            onClick={() => {
                                goCancelPayment();
                            }}
                            fullWidth
                            loading={isLoading}
                        >
                            취소시키기
                        </Button>
                    )
                }

                if (toBeCanceled && (params.row.type === "terminal" || params.row.type === "forcePayment" || params.row.type === "withdrawal") && !params.row.canceledAt) {

                    return (
                        <Button
                            variant="outlined"
                            color="danger"
                            size="sm"
                            onClick={() => {
                                goCancelPayment();
                            }}
                            fullWidth
                            loading={isLoading}
                        >
                            취소확정
                        </Button>

                    )

                }
            }
        },
        {
            field: "canceledAt", headerName: "취소일자", width: 200
        },
        {
            field : "createCancelRefundGood", headerName : "환불상품생성", width : 130,
            renderCell : (params : any) => {

                const toBeCanceled = params.row.toBeCanceled;
                const orderId = params.row.orderId;

                const startDate = params.row.startDate;
                const endDate = params.row.endDate;
                const price = params.row.amountRaw;

                const hasUnpaidOrderItem = params.row.hasUnpaidOrderItem;

                const createRefundGood = async () => {

                    if (hasUnpaidOrderItem) {
                        alert("미결제된 상품이 존재하는 상태에서는 환불상품을 생성할 수 없습니다.");
                        return;
                    }

                    setSelectedStartDate(startDate);
                    setSelectedEndDate(endDate);
                    setSelectedPrice(price);
                    setModalOpen(true);
                    setSelectedLinkedOrderId(orderId);

                    return;
                
                }

                return (
                    <div>
                        {
                            (toBeCanceled && !params.row.canceledAt) ? 
                            <div>
                                <Button
                                    variant="outlined"
                                    color="neutral"
                                    size="sm"
                                    onClick={createRefundGood}
                                    fullWidth
                                    loading={!!loadingMap[orderId]}
                                >
                                    환불상품생성
                                </Button>

                            </div>
                            :
                            ""
                        }
                    </div>
                )

            }
        }
    ], [props.selectedPaidOrderItems, props.update, loadingMap]);
    const [update, setUpdate] = useState(0);

    const [modalOpen, setModalOpen] = useState<boolean>(false);

    const handleClose = () => {
        setModalOpen(false);

        setSelectedStartDate(null);
        setSelectedEndDate(null);
        setSelectedPrice(0);
    }


    useEffect(() => {

        if (!props.userId) return;

        if (!props.open) return;

        const selectedPaidOrderItems = props.selectedPaidOrderItems;

        start(selectedPaidOrderItems);

    }, [props.userId, props.open, update, props.selectedPaidOrderItems, props.update, props.totalTeacherData]);

    const start = (selectedPaidOrderItems: any[]) => {

        console.log("selectedPaidOrderItems");
        console.log(selectedPaidOrderItems);

        if (!selectedPaidOrderItems || selectedPaidOrderItems.length === 0) {
            setRows([]);
            return;
        }

        const newRows: any[] = [];

        var hasUnpaidOrderItem = false;

        selectedPaidOrderItems.forEach((item: any) => {

            if(!item.canceled && !item.isPaid){
                hasUnpaidOrderItem = true;
            }

        });

        selectedPaidOrderItems.forEach((item: any, index: number) => {

            if (!item) return;

            if (item.totalPaymentRecords.length === 0) {
                return;
            }

            const startDate = new Date(item.startDate);
            const endDate = new Date(item.endDate);

            const startDateString = `${dateToDateString(startDate)}`;
            const endDateString = `${dateToDateString(endDate)}`;

            item.totalPaymentRecords.forEach((paymentRecord: any, index: number) => {

                const oneRow: any = {};



                oneRow.id = paymentRecord.id;
                oneRow.hasUnpaidOrderItem = hasUnpaidOrderItem;
                oneRow.goodId = item.id;
                oneRow.price = index === 0 ? item.price.toLocaleString() : "";
                oneRow.goodName = index === 0 ? `${startDateString}~${endDateString}` : "";
                oneRow.startDate = startDate;
                oneRow.endDate = endDate;
                oneRow.kindName = kindNaming(paymentRecord.kind);
                oneRow.kind = paymentRecord.kind;
                oneRow.type = paymentRecord.type;
                oneRow.status = paymentRecord.canceled ? "취소됨" : "결제완료";
                oneRow.amount = paymentRecord.price.toLocaleString();
                oneRow.amount += ` ${(item.diff_amount < 0 && !paymentRecord.canceled) ? `(잔여 ${Math.abs(item.diff_amount).toLocaleString()})` : ""}`;
                oneRow.amountRaw = paymentRecord.price;
                oneRow.createdAt = dateToDateString(new Date(paymentRecord.createdAt), true);
                const kindName = kindNaming(paymentRecord.type);
                oneRow.kindName = kindName;

                if (paymentRecord.type === "forcePayment") {
                    props.totalTeacherData.forEach((teacherItem: any) => {
                        const teacherId = teacherItem.id;
                        const forcedBy = paymentRecord.forcedBy;

                        if (teacherId === forcedBy) {
                            oneRow.kindName = `수동결제(${teacherItem.name})_${paymentRecord.forcedMemo}`;
                        }

                    });
                }

                oneRow.forceImg = paymentRecord.forcedImg ? paymentRecord.forcedImg : null;

                oneRow.payTeacherBillId = paymentRecord.payTeacherBillId ? paymentRecord.payTeacherBillId : null;
                oneRow.orderId = item.id;
                oneRow.toBeCanceled = item.toBeCanceled;
                oneRow.canceledAt = paymentRecord.canceled ? dateToDateString(new Date(paymentRecord.canceledAt), true) : "";
                oneRow.index = index;

                newRows.push(oneRow);

            });


        });

        setRows([...newRows]);

    }

    const makeRow = (oneRow: any, item: any) => {

    }

    const kindNaming = (kind: string) => {

        var kindName = "";

        switch (kind) {
            case "card":
                kindName = "카드결제";
                break;
            case "cash":
                kindName = "현금결제";
                break;
            case "withdrawal":
                kindName = "계좌이체";
                break;
            case "kiosk":
                kindName = "키오스크결제";
                break;
            case "forcePayment":
                kindName = "수동결제";
                break;
            case "payTeacher":
                kindName = "결제선생";
                break;
            case "terminal":
                kindName = "단말기결제";
                break;
        }

        return kindName;

    }

    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
            sx={{
                backdropFilter: "blur(0px)",
                zIndex : 0
            }}
        >
            <ModalDialog sx={{
                borderRadius: "30px"
            }}>
                <div style={{
                    width: "1500px",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    height: "650px",
                    fontFamily: "Apple_R",
                }}>
                    <div className={classes.root} style={{
                        width: "100%",
                        height: "100%",
                    }}>
                        <StyledDataGrid
                            rows={rows}
                            columns={columns}
                            density="compact"
                            getCellClassName={(params) => {
                                if (params.field === "status") {
                                    if (params.value === "결제완료") {
                                        return "softblue";
                                    } else if (params.value && params.value.includes("취소")) {
                                        return "softred";
                                    }
                                }
                                return ""
                            }}
                            disableRowSelectionOnClick
                        />
                    </div>
                </div>

                <ImageModal2
                    open={open3}
                    handleClose={() => { setOpen3(false) }}
                    src={[imageSrc]}
                />

                <AddGoodModalForRefund
                    open={modalOpen}
                    handleClose={handleClose}
                    setUpdate={props.setUpdate}
                    userId={props.userId}
                    selectedStartDate={selectedStartDate}
                    selectedEndDate={selectedEndDate}
                    selectedPrice={selectedPrice}
                    registerPayInfo={props.registerPayInfo}
                    selectedStudent={props.selectedStudent}
                    notify={props.notify18}
                    linkedOrderId={selectedLinkedOrderId}
                />




            </ModalDialog>
        </Modal>
    )
}

export default PaidModal;